/**
 * Specifies supported locales in the web and exports url slug translations
 * comma separated list of supported locales for easy access when needed:
 * en, cs, da, nl, fi, fr, de, it, no, pl, ru, sv, es, pt-BR, pt-PT
 */
declare var IS_PRODUCTION: boolean

export type LanguageCodes =
  | 'cs'
  | 'da'
  | 'de'
  | 'en'
  | 'es'
  | 'fi'
  | 'fr'
  | 'it'
  | 'nl'
  | 'no'
  | 'pl'
  | 'pt'
  | 'ru'
  | 'sv'
  | 'pt-pt'

export const languageSlugAliases = {
  'pt-br': 'pt',
} as const

export const language = {
  ENGLISH: 'en',
  CZECH: 'cs',
  DANISH: 'da',
  DUTCH: 'nl',
  FINNISH: 'fi',
  FRENCH: 'fr',
  GERMAN: 'de',
  ITALIAN: 'it',
  NORWEGIAN: 'no',
  POLISH: 'pl',
  PORTUGUESE: 'pt',
  RUSSIAN: 'ru',
  SPANISH: 'es',
  SWEDISH: 'sv',
  PORTUGUESE_PT: 'pt-pt',
  ...(IS_PRODUCTION
    ? {}
    : {
        X_LONGEST: 'xl',
        X_PSEUDO: 'xp',
      }),
} as unknown as { [key: string]: LanguageCodes }

export const smartlingLocales = {
  en: 'en',
  da: 'da-DK',
  nl: 'nl-NL',
  fi: 'fi-FI',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  no: 'no-NO',
  ru: 'ru-RU',
  sv: 'sv-SE',
  es: 'es-LA',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
}

export const apiLocales = {
  en: 'en-US',
  da: 'da-DK',
  nl: 'nl-NL',
  fi: 'fi-FI',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  no: 'nb-NO',
  ru: 'ru-RU',
  sv: 'sv-SE',
  es: 'es-LA',
  pt: 'pt-BR',
  'pt-pt': 'pt-PT',
}

export const languages = Object.values(language).sort() as LanguageCodes[]

export const translatedLanguageNames = {
  en: 'English',
  cs: 'Čeština',
  nl: 'Nederlands',
  sv: 'Svenska',
  fi: 'Suomi',
  fr: 'Français',
  de: 'Deutsch',
  no: 'Norsk',
  pl: 'Polski',
  ru: 'Русский',
  da: 'Dansk',
  it: 'Italiano',
  es: 'Español',
  pt: 'Português',
  'pt-pt': 'Português (Portugal)',
  ...(IS_PRODUCTION
    ? {}
    : {
        xp: 'ƤŞḖḖŬŬḒǾǾ',
        xl: 'LONGEST TRANSLATION',
      }),
}

export const languageNames = {
  en: 'English',
  cs: 'Czech',
  nl: 'Dutch',
  sv: 'Swedish',
  fi: 'Finnish',
  fr: 'French',
  de: 'German',
  no: 'Norwegian',
  pl: 'Polish',
  ru: 'Russian',
  da: 'Danish',
  it: 'Italian',
  es: 'Spanish',
  pt: 'Portuguese',
  'pt-pt': 'Portuguese (Portugal)',
}

export const currency = {
  USD: 'USD',
  AUD: 'AUD',
  CHF: 'CHF',
  DKK: 'DKK',
  EUR: 'EUR',
  GBP: 'GBP',
  NOK: 'NOK',
  NZD: 'NZD',
  SEK: 'SEK',
  CAD: 'CAD',
  BRL: 'BRL',
  MXN: 'MXN',
  INR: 'INR',
}

export type CurrencyCodes = keyof typeof currency

export const currencies = Object.values(currency)
